// extracted by mini-css-extract-plugin
export var active = "_g8-7";
export var blink = "_g8-8";
export var dropDownSelector = "_g8-4";
export var dropDownWrapper = "_g8-3";
export var fakeCursor = "_g8-6";
export var fontSizeButton = "_g8-9";
export var formQuillEditor = "_g8-0";
export var pressed = "_g8-a";
export var qlBlank = "_g8-1";
export var textFormattingToolbar = "_g8-2";
export var textToolbarOption = "_g8-5";